<template>
  <b-modal
    ref="modal-failed"
    id="modal-failed"
    centered
    hide-footer
    hide-header
  >
    <div class="px-3 py-5 text-center">
      <img src="@/assets/icon-delete.png" alt="" width="120" height="120" />
      <h4 class="text-bold mt-4">Failed</h4>
      <h6 class="text-bold mt-4">{{ message.message }}</h6>
      <p class="text-muted mb-3">
        {{ message.errors ? message.errors : message.stack ? message.stack : 'You have failed to upload the summary survey' }}
      </p>
      <b-button
        class="btn-custom px-4 mt-3"
        variant="info"
        @click="$bvModal.hide('modal-failed')"
      >
        Back
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    message: {
      message: '',
      errors: '',
      code: '',
      stack: ''
    }
  }
}
</script>

<style lang="scss">
.error-text {
  height: 150px;
  overflow: auto;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}
</style>
